import { canViewAdvancedCareActivityNotes } from "@/features/acp/helpers/note-access";

type NoteType = {
  id: string;
  name: string;
};

const NOTE_TYPE_FILTER_OPTIONS: NoteType[] = [
  { id: "all", name: "All" },
  { id: "BHS", name: "Behavioral Health Specialist" },
  { id: "PRESCRIBE", name: "Prescriber" },
  { id: "CASE_MANAGER", name: "Case Manager" },
  { id: "PEER", name: "Peer" },
  { id: "Check-in", name: "Check-in" },
  { id: "Care Coordination", name: "Care Coordination" },
  { id: "Care Communication", name: "Care Communication" },
  { id: "Case Management", name: "Case Management" },
  { id: "Care Management", name: "Care Management" },
] as const;

export function getNoteTypeFilterOptions() {
  if (canViewAdvancedCareActivityNotes()) {
    return [
      ...NOTE_TYPE_FILTER_OPTIONS,
      { id: "Advanced Care Activity", name: "Advanced Care Activity" },
    ];
  }

  return NOTE_TYPE_FILTER_OPTIONS;
}
